// Formik value keys are written in the format: {{ facetName }}_{{ attribute }}.
// We have to map this to a nested object, in order to pass it as the new facet values.
export function mapValuesToFacets(values) {
  const newFacets = {};
  const valueKeys = Object.keys(values);
  valueKeys.forEach(key => {
    const [facetType, facetAttribute] = key.split(/_(.*)/);
    if (newFacets[facetType]) {
      newFacets[facetType] = {
        [facetAttribute]: values[key]
      };
    }
  });
  return newFacets;
}

// Opposite function to mapValuesToFacets.
export function mapFacetsToValues(facets) {
  const newValues = {};
  function recursivelyFlattenFacets(nestedFacets, target, flattenedKey) {
    const keys = Object.keys(nestedFacets);
    keys.forEach(key => {
      if (!nestedFacets[key]) {
        return;
      }
      const newKey = flattenedKey === undefined ? key : "".concat(flattenedKey, "_").concat(key);
      const value = nestedFacets[key];
      if (typeof value === 'object' && !Array.isArray(value)) {
        // No idea how to solve this typescript issue.
        // @ts-ignore
        recursivelyFlattenFacets(value, target, newKey);
      } else {
        // eslint-disable-next-line no-param-reassign
        target[newKey] = value;
      }
    });
    return target;
  }
  return recursivelyFlattenFacets(facets, newValues);
}